module.exports = __webpack_public_path__ + "img/Setting-industry.b316064c.png";